import { useSearchParams } from "react-router-dom";
import { DebouncedInput } from "@altimateai/lego";
import { SearchIcon } from "@/assets/icons";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { SEARCH_PARAMS } from "@/pages/subscriptions/constants";

export const SubscriptionSearchBar = () => {
  const [searchParams] = useSearchParams();
  const { updateSearchParamsByKey } = useFiltersBySearchParams();

  const searchValue = searchParams.get(SEARCH_PARAMS.SEARCH) || "";

  const handleSearchChange = (value: string) => {
    updateSearchParamsByKey({ [SEARCH_PARAMS.SEARCH]: value });
  };

  return (
    <div className="al-w-full al-max-w-xs">
      <DebouncedInput
        type="search"
        placeholder="Search subscriptions by name"
        value={searchValue}
        onChange={handleSearchChange}
        debounceMs={300}
        icon={SearchIcon}
        iconPosition="left"
      />
    </div>
  );
};
